import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { hot } from 'react-hot-loader';
import { useHistory } from 'react-router-dom';
import update from 'immutability-helper';
import "react-datepicker/dist/react-datepicker.css";

import { withLocale } from 'op/components/locale';
import { withAuditForm } from './audit-form.helper';
import getDateTimeString from 'op/utils/getDateTimeString';
import AuditFormComponent from './audit-form-component';

var AuditFormContainer = function(props) {
  var locale = props.locale;
  var loading = props.loading;
  var unitTree = props.unitTree;
  var mainCategories = props.mainCategories;
  var subCategories = props.subCategories;
  var fetchSubCategories = props.fetchSubCategories;
  var user = props.user;
  var axios = props.axios;
  var setSaving = props.setSaving;
  var saving = props.saving;
  var mainStatuses = props.mainStatuses;
  var followupTypes = props.followupTypes;
  var trainingEventTypes = props.trainingEventTypes || [];

  var history = useHistory();

  var initialForm = {
    INS_MainAuditDate: new Date(),
    RDS_Unit_ID: null,
    INS_SubCategoryID: null,
    INS_MainAuditUserName: (user && user.username) || '',
    INS_MainAuditManagerName: '',
    INS_MainAuditFollowupManagerName: '',
    INS_MainAuditLocation: '',
    INS_MainAuditSubLocation: '',
    INS_MainAuditGeneralComments: '',
    INS_MainAuditGeneralFollowup: '',
    INS_MainAuditGeneralFollowupResult: '',
    INS_MainAuditGeneralFollowupDate: null,
    INS_MainAuditManagerSig: '',
    INS_MainAuditEmployeeSig: '',
    INS_MainAuditUpload1: '',
    INS_MainAuditUpload2: '',
    INS_MainAuditUpload3: '',
    INS_MainAuditUploadFilename1: '',
    INS_MainAuditUploadFilename2: '',
    INS_MainAuditUploadFilename3: '',
  };

  var reportInitial = {
    signatures: {
      EmpSig: undefined,
      SSOSig: undefined,
    }
  };

  var reportState = useState(reportInitial);
  var report = reportState[0];
  var setReport = reportState[1];

  var formState = useState(initialForm);
  var form = formState[0];
  var setForm = formState[1];

  var auditCreatedState = useState(false);
  var auditCreated = auditCreatedState[0];
  var setAuditCreated = auditCreatedState[1];

  var createdAuditIdState = useState(null);
  var createdAuditId = createdAuditIdState[0];
  var setCreatedAuditId = createdAuditIdState[1];

  var isKPIMngState = useState(false);
  var isKPIMng = isKPIMngState[0];
  var setIsKPIMng = isKPIMngState[1];

  var isFollowupMngState = useState(false);
  var isFollowupMng = isFollowupMngState[0];
  var setIsFollowupMng = isFollowupMngState[1];

  var auditFollowupsState = useState([]);
  var auditFollowups = auditFollowupsState[0];
  var setAuditFollowups = auditFollowupsState[1];

  var kpiTypesState = useState([]);
  var kpiTypes = kpiTypesState[0];
  var setKpiTypes = kpiTypesState[1];

  var kpiDataState = useState([]);
  var kpiData = kpiDataState[0];
  var setKpiData = kpiDataState[1];

  var kpiNamesState = useState([]);
  var kpiNames = kpiNamesState[0];
  var setKpiNames = kpiNamesState[1];

  var selectedMainCategoryState = useState(null);
  var selectedMainCategory = selectedMainCategoryState[0];
  var setSelectedMainCategory = selectedMainCategoryState[1];

  var selectedStatusIdState = useState(null);
  var selectedStatusId = selectedStatusIdState[0];
  var setSelectedStatusId = selectedStatusIdState[1];

  var statusRemarksState = useState('');
  var statusRemarks = statusRemarksState[0];
  var setStatusRemarks = statusRemarksState[1];

  var isEmployeeMngState = useState(false);
  var isEmployeeMng = isEmployeeMngState[0];
  var setIsEmployeeMng = isEmployeeMngState[1];

  var unitPersonsState = useState([]);
  var unitPersons = unitPersonsState[0];
  var setUnitPersons = unitPersonsState[1];

  var auditPersonsState = useState([]);
  var auditPersons = auditPersonsState[0];
  var setAuditPersons = auditPersonsState[1];

  var employeesModalOpenState = useState(false);
  var employeesModalOpen = employeesModalOpenState[0];
  var setEmployeesModalOpen = employeesModalOpenState[1];

  var trainingEventCategoriesState = useState([]);
  var trainingEventCategories = trainingEventCategoriesState[0];
  var setTrainingEventCategories = trainingEventCategoriesState[1];

  var invokeChange = function(change) {
    setReport(update(report, change));
  };

  useEffect(function() {
    if (report.signatures.EmpSig) {
      setForm(function(prev) {
        return Object.assign({}, prev, {
          INS_MainAuditEmployeeSig: report.signatures.EmpSig.replace('data:image/png;base64,', '')
        });
      });
    }
  }, [report.signatures.EmpSig]);

  useEffect(function() {
    if (report.signatures.SSOSig) {
      setForm(function(prev) {
        return Object.assign({}, prev, {
          INS_MainAuditManagerSig: report.signatures.SSOSig.replace('data:image/png;base64,', '')
        });
      });
    }
  }, [report.signatures.SSOSig]);

  var handleCreateAudit = function() {
    setSaving(true);
    // Do not call saveMainAudit on Create — first save happens on "Save Audit"
    setCreatedAuditId(null);

    var mainCat = mainCategories.find(function(c) {
      return c.inS_MainCategoryID === selectedMainCategory;
    });

    if (mainCat && mainCat.inS_MainCategoryIsEmployeeMng) {
      setIsEmployeeMng(true);
    }

    if (mainCat && mainCat.inS_MainCategoryIsFollowupMng) {
      setIsFollowupMng(true);
    }

    if (mainCat && mainCat.inS_MainCategoryIsKPIMng) {
      setIsKPIMng(true);
      var names = [];
      if (mainCat.inS_MainCategoryKPI1Name) names.push({ index: 1, name: mainCat.inS_MainCategoryKPI1Name });
      if (mainCat.inS_MainCategoryKPI2Name) names.push({ index: 2, name: mainCat.inS_MainCategoryKPI2Name });
      if (mainCat.inS_MainCategoryKPI3Name) names.push({ index: 3, name: mainCat.inS_MainCategoryKPI3Name });
      if (mainCat.inS_MainCategoryKPI4Name) names.push({ index: 4, name: mainCat.inS_MainCategoryKPI4Name });
      if (mainCat.inS_MainCategoryKPI5Name) names.push({ index: 5, name: mainCat.inS_MainCategoryKPI5Name });
      setKpiNames(names);

      axios.get('/api/Audit/getKpiTypes?subCategoryId=' + form.INS_SubCategoryID)
        .then(function(kpiRes) {
          var types = kpiRes.data || [];
          setKpiTypes(types);
          var initialKpiData = types.map(function(kpiType) {
            return {
              INS_MainAuditID: null,
              INS_KPITypeID: kpiType.inS_KPITypeID || kpiType.INS_KPITypeID,
              INS_MainCategoryKPI: 0,
              INS_MainAuditKPIRemarks: '',
              INS_MainAuditKPIFollowup: '',
              INS_MainAuditKPIFollowupResult: '',
              INS_MainAuditKPIFollowupAlert: false,
              INS_MainAuditKPIFollowupDate: null,
              kpiTypeName: kpiType.inS_KPITypeName || kpiType.INS_KPITypeName,
              kpiTypeDescription: kpiType.inS_KPITypeDescription || kpiType.INS_KPITypeDescription || '',
            };
          });
          setKpiData(initialKpiData);
          setSaving(false);
          setAuditCreated(true);
        })
        .catch(function() {
          setSaving(false);
          setAuditCreated(true);
        });
    } else {
      setSaving(false);
      setAuditCreated(true);
    }
  };

  var handleSubmit = function() {
    setSaving(true);
    var formData = {
      INS_MainAuditID: createdAuditId,
      RDS_Unit_ID: form.RDS_Unit_ID,
      INS_SubCategoryID: form.INS_SubCategoryID,
      INS_MainAuditDate: form.INS_MainAuditDate ? getDateTimeString(form.INS_MainAuditDate) : null,
      INS_MainAuditUserName: form.INS_MainAuditUserName,
      INS_MainAuditManagerName: form.INS_MainAuditManagerName,
      INS_MainAuditFollowupManagerName: form.INS_MainAuditFollowupManagerName,
      INS_MainAuditLocation: form.INS_MainAuditLocation,
      INS_MainAuditSubLocation: form.INS_MainAuditSubLocation,
      INS_MainAuditGeneralComments: form.INS_MainAuditGeneralComments,
      INS_MainAuditGeneralFollowup: form.INS_MainAuditGeneralFollowup,
      INS_MainAuditGeneralFollowupResult: form.INS_MainAuditGeneralFollowupResult,
      INS_MainAuditGeneralFollowupDate: form.INS_MainAuditGeneralFollowupDate
        ? getDateTimeString(form.INS_MainAuditGeneralFollowupDate)
        : null,
      INS_MainAuditManagerSig: form.INS_MainAuditManagerSig || null,
      INS_MainAuditEmployeeSig: form.INS_MainAuditEmployeeSig || null,
      INS_MainAuditUpload1: form.INS_MainAuditUpload1 || null,
      INS_MainAuditUpload2: form.INS_MainAuditUpload2 || null,
      INS_MainAuditUpload3: form.INS_MainAuditUpload3 || null,
      INS_MainAuditUploadFilename1: form.INS_MainAuditUploadFilename1 || null,
      INS_MainAuditUploadFilename2: form.INS_MainAuditUploadFilename2 || null,
      INS_MainAuditUploadFilename3: form.INS_MainAuditUploadFilename3 || null,
    };

    var saveAuditPromise = axios.post('/api/Audit/saveMainAudit', formData);

    var promises = [saveAuditPromise];

    if (isKPIMng && kpiData.length > 0) {
      var kpiModels = kpiData
        .filter(function(kpi) { return kpi.INS_MainCategoryKPI > 0; })
        .map(function(kpi) {
          return {
            INS_MainAuditID: createdAuditId,
            INS_KPITypeID: kpi.INS_KPITypeID,
            INS_MainCategoryKPI: kpi.INS_MainCategoryKPI,
            INS_MainAuditKPIRemarks: kpi.INS_MainAuditKPIRemarks || null,
            INS_MainAuditKPIFollowup: kpi.INS_MainAuditKPIFollowup || null,
            INS_MainAuditKPIFollowupResult: kpi.INS_MainAuditKPIFollowupResult || null,
            INS_MainAuditKPIFollowupAlert: kpi.INS_MainAuditKPIFollowupAlert || false,
            INS_MainAuditKPIFollowupDate: kpi.INS_MainAuditKPIFollowupDate ? getDateTimeString(kpi.INS_MainAuditKPIFollowupDate instanceof Date ? kpi.INS_MainAuditKPIFollowupDate : new Date(kpi.INS_MainAuditKPIFollowupDate)) : null,
            INS_MainAuditKPI1Value: kpi.INS_MainAuditKPI1Value || 0,
            INS_MainAuditKPI2Value: kpi.INS_MainAuditKPI2Value || 0,
            INS_MainAuditKPI3Value: kpi.INS_MainAuditKPI3Value || 0,
            INS_MainAuditKPI4Value: kpi.INS_MainAuditKPI4Value || 0,
            INS_MainAuditKPI5Value: kpi.INS_MainAuditKPI5Value || 0,
          };
        });

      if (kpiModels.length > 0) {
        var kpiPromise = saveAuditPromise.then(function(res) {
          var auditId = createdAuditId != null ? createdAuditId : (res.data.inS_MainAuditID != null ? res.data.inS_MainAuditID : res.data.INS_MainAuditID);
          var modelsWithId = kpiModels.map(function(m) { return Object.assign({}, m, { INS_MainAuditID: auditId }); });
          return axios.post('/api/Audit/saveAuditKpiBulk', modelsWithId);
        });
        promises.push(kpiPromise);
      }
    }

    if (selectedStatusId) {
      var statusPromise = saveAuditPromise.then(function(res) {
        var auditId = createdAuditId != null ? createdAuditId : (res.data.inS_MainAuditID != null ? res.data.inS_MainAuditID : res.data.INS_MainAuditID);
        return axios.post('/api/Audit/saveAuditStatus', {
          INS_MainAuditID: auditId,
          INS_MainStatusID: selectedStatusId,
          INS_AuditStatus_StatusDate: getDateTimeString(new Date()),
          INS_AuditStatus_StatusRemarks: statusRemarks || null,
        });
      });
      promises.push(statusPromise);
    }

    if (auditPersons.length > 0) {
      var personPromises = auditPersons.map(function(person) {
        return saveAuditPromise.then(function(res) {
          var auditId = createdAuditId != null ? createdAuditId : (res.data.inS_MainAuditID != null ? res.data.inS_MainAuditID : res.data.INS_MainAuditID);
          return axios.post('/api/Audit/saveAuditPerson', Object.assign({}, person, { INS_MainAuditID: auditId }));
        });
      });
      promises = promises.concat(personPromises);
    }

    if (auditFollowups.length > 0) {
      var followupPromises = auditFollowups.map(function(followup) {
        return saveAuditPromise.then(function(res) {
          var auditId = createdAuditId != null ? createdAuditId : (res.data.inS_MainAuditID != null ? res.data.inS_MainAuditID : res.data.INS_MainAuditID);
          return axios.post('/api/Audit/saveMainAuditFollowup', Object.assign({}, followup, { INS_MainAuditID: auditId }));
        });
      });
      promises = promises.concat(followupPromises);
    }

    Promise.all(promises)
      .then(function() {
        setSaving(false);
        history.push('/audit');
      })
      .catch(function() {
        setSaving(false);
      });
  };

  var handleKpiExecutionChange = function(kpiTypeId, kpiValue) {
    setKpiData(function(prev) {
      return prev.map(function(kpi) {
        if (kpi.INS_KPITypeID === kpiTypeId) {
          return Object.assign({}, kpi, {
            INS_MainCategoryKPI: kpiValue,
            INS_MainAuditKPI1Value: kpiValue === 1 ? 1 : 0,
            INS_MainAuditKPI2Value: kpiValue === 2 ? 1 : 0,
            INS_MainAuditKPI3Value: kpiValue === 3 ? 1 : 0,
            INS_MainAuditKPI4Value: kpiValue === 4 ? 1 : 0,
            INS_MainAuditKPI5Value: kpiValue === 5 ? 1 : 0,
          });
        }
        return kpi;
      });
    });
  };

  var handleKpiFieldChange = function(kpiTypeId, field, value) {
    setKpiData(function(prev) {
      return prev.map(function(kpi) {
        if (kpi.INS_KPITypeID === kpiTypeId) {
          var update = {};
          update[field] = value;
          return Object.assign({}, kpi, update);
        }
        return kpi;
      });
    });
  };

  var handleOpenEmployeesModal = function() {
    setEmployeesModalOpen(true);
    if (form.RDS_Unit_ID) {
      axios.get('/api/Audit/getPersonsByUnit?unitId=' + form.RDS_Unit_ID)
        .then(function(res) {
          setUnitPersons(res.data || []);
        })
        .catch(function() {});
    }
  };

  var handlePersonTaskTypeChange = function(typeId) {
    if (!typeId) {
      setTrainingEventCategories([]);
      return;
    }
    axios.get('/api/Tasks/eventcategory?typeID=' + typeId)
      .then(function(res) { setTrainingEventCategories(res.data || []); })
      .catch(function() { setTrainingEventCategories([]); });
  };

  var handleAddAuditPerson = function(personId, followupAlert, followupRemarks, followupResultDate, taskCategoryId) {
    var saveModel = {
      INS_MainAuditID: 0,
      RDS_Person_ID: personId,
      RDS_TrainingEventCategory_ID: taskCategoryId || null,
      INS_MainAudit2PersonFollowupAlert: followupAlert || false,
      INS_MainAudit2PersonFollowupRemarks: followupRemarks || null,
      INS_MainAudit2PersonFollowupResultDate: followupResultDate ? getDateTimeString(followupResultDate instanceof Date ? followupResultDate : new Date(followupResultDate)) : null,
    };
    setAuditPersons(function(prev) {
      var exists = prev.find(function(p) { return p.RDS_Person_ID === personId; });
      if (exists) {
        return prev.map(function(p) {
          if (p.RDS_Person_ID === personId) {
            return Object.assign({}, p, {
              RDS_TrainingEventCategory_ID: saveModel.RDS_TrainingEventCategory_ID,
              INS_MainAudit2PersonFollowupAlert: saveModel.INS_MainAudit2PersonFollowupAlert,
              INS_MainAudit2PersonFollowupRemarks: saveModel.INS_MainAudit2PersonFollowupRemarks,
              INS_MainAudit2PersonFollowupResultDate: saveModel.INS_MainAudit2PersonFollowupResultDate,
            });
          }
          return p;
        });
      }
      return prev.concat([saveModel]);
    });
  };

  var handleDeleteAuditPerson = function(personId) {
    setAuditPersons(function(prev) {
      return prev.filter(function(p) { return p.RDS_Person_ID !== personId; });
    });
  };

  var handleAddFollowup = function(followup) {
    setAuditFollowups(function(prev) {
      return prev.concat([followup]);
    });
  };

  var handleDeleteFollowup = function(index) {
    setAuditFollowups(function(prev) {
      return prev.filter(function(_, i) { return i !== index; });
    });
  };

  var handleBackClick = function() {
    if (auditCreated) {
      setAuditCreated(false);
    } else {
      history.push('/audit');
    }
  };

  return React.createElement(AuditFormComponent, {
    locale: locale,
    loading: loading,
    unitTree: unitTree,
    mainCategories: mainCategories,
    subCategories: subCategories,
    fetchSubCategories: fetchSubCategories,
    saving: saving,
    form: form,
    setForm: setForm,
    report: report,
    invokeChange: invokeChange,
    onCreateAudit: handleCreateAudit,
    onSubmit: handleSubmit,
    auditCreated: auditCreated,
    isKPIMng: isKPIMng,
    kpiTypes: kpiTypes,
    kpiData: kpiData,
    kpiNames: kpiNames,
    selectedMainCategory: selectedMainCategory,
    setSelectedMainCategory: setSelectedMainCategory,
    onKpiExecutionChange: handleKpiExecutionChange,
    onKpiFieldChange: handleKpiFieldChange,
    onBackClick: handleBackClick,
    mainStatuses: mainStatuses,
    selectedStatusId: selectedStatusId,
    setSelectedStatusId: setSelectedStatusId,
    statusRemarks: statusRemarks,
    setStatusRemarks: setStatusRemarks,
    isEmployeeMng: isEmployeeMng,
    unitPersons: unitPersons,
    auditPersons: auditPersons,
    employeesModalOpen: employeesModalOpen,
    setEmployeesModalOpen: setEmployeesModalOpen,
    onOpenEmployeesModal: handleOpenEmployeesModal,
    onAddAuditPerson: handleAddAuditPerson,
    onDeleteAuditPerson: handleDeleteAuditPerson,
    followupTypes: followupTypes,
    isFollowupMng: isFollowupMng,
    auditFollowups: auditFollowups,
    onAddFollowup: handleAddFollowup,
    onDeleteFollowup: handleDeleteFollowup,
    trainingEventTypes: trainingEventTypes,
    trainingEventCategories: trainingEventCategories,
    onPersonTaskTypeChange: handlePersonTaskTypeChange
  });
};

export default compose(
  hot(module),
  withLocale('audit'),
  withAuditForm
)(AuditFormContainer);
